export const BUSINESS_PARTNER_CENTER_TRANSLATIONS_EN = {
  overview: 'Overview',
  'master-data': 'Master Data',
  activities: 'Activities',
  contacts: 'Contacts',
  orders: 'Orders',
  budgets: 'Budgets',
  appointments: 'Appointments',
  planning: 'Planning',
  documentations: 'Documentations',
  ratings: 'Ratings',
  'contract-data': 'Contract Data',
  'working-hours': 'Working Hours',
  workContract: 'Work Contract',
  files: 'Files',
  tickets: 'Tickets',
  other: 'Other',
  controlling: 'Controlling',
  employees: 'Employees',
  mobility: 'Mobility',
  'payroll-data': 'Payroll Data',
  absences: 'Absences',
};
